import { render } from "./EditDriver.vue?vue&type=template&id=dbe92a84"
import script from "./EditDriver.vue?vue&type=script&lang=js"
export * from "./EditDriver.vue?vue&type=script&lang=js"
script.render = render

export default script